// The Reports toasts: a success fades by itself; a refusal stays until dismissed,
// at most MAX_ERRORS at once, the oldest giving way.
export type Toast = { id: number; text: string; kind?: 'error' }

export const MAX_ERRORS = 3

/** The list with t added, keeping only the newest MAX_ERRORS refusals. */
export function addToast(list: Toast[], t: Toast): Toast[] {
  const next = [...list, t]
  const errors = next.filter((x) => x.kind === 'error')
  if (errors.length <= MAX_ERRORS) return next
  const drop = new Set(errors.slice(0, errors.length - MAX_ERRORS).map((x) => x.id))
  return next.filter((x) => !drop.has(x.id))
}

/** The refusal Escape closes: the newest. */
export function newestError(list: Toast[]): Toast | undefined {
  return [...list].reverse().find((x) => x.kind === 'error')
}

const NOT_TYPING = new Set(['button', 'checkbox', 'radio', 'submit', 'reset', 'range', 'color', 'file', 'image'])

/** Whether focus is somewhere a person types, which a toast must never take it from. */
export function typingIn(el: { tagName?: string; type?: string; isContentEditable?: boolean } | null | undefined): boolean {
  if (!el?.tagName) return false
  const tag = el.tagName.toLowerCase()
  if (tag === 'textarea' || tag === 'select' || el.isContentEditable) return true
  return tag === 'input' && !NOT_TYPING.has((el.type ?? 'text').toLowerCase())
}
